/* eslint-disable import/prefer-default-export */

export const pageview = url => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    window.dataLayer.push({
        event: 'pageview',
        page: url,
    });
};
